import React from 'react';
import { useTranslation } from 'react-i18next';
import { getCardApiValue, formatValue } from '../helpers';
import { checkKpiType } from '@flexo/general';

interface InformationCardContentKeyValueProps {
  description: any[];
  overviewKpiApiData: any[];
  kpiContext: string;
  currencyFields: string[];
}

const InformationCardContentKeyValue: React.FC<InformationCardContentKeyValueProps> = ({ description, overviewKpiApiData, kpiContext, currencyFields }) => {
  const { t } = useTranslation();
  return (
    <>
      {description?.map((el, i) => {
        const valueObj = getCardApiValue(el?.value, overviewKpiApiData, currencyFields);
        return (
          <div key={`key-value-${i}`}>
            <div>
              <span className="paragraph">{t(el.key)} </span>
              <span className="heading5">
                {' '}
                {formatValue(valueObj?.value || '-.- ', kpiContext, checkKpiType) +
                  (valueObj?.unit || valueObj?.unit_type || '')}
              </span>
            </div>
          </div>
        );
      })}
    </>
  );
};

export default InformationCardContentKeyValue; 